import { Outlet, useLocation, useNavigate } from "react-router-dom";
import ContainerNavigation from "../../components/ContainerNavigation";
import { useNavigationBar } from "../../context/NavigationContext";
import ModeratorChannelProvider, { ModeratorChannelContext } from "../../context/ModerationChannelContext";
import { CreateChannelContext } from "../../context/CreateChannelContext";
import { useContext, useState } from "react";
import { ChannelState, getChannelEditStatusString, getChannelStatusString } from "../../models/SKChannel";
import { ChannelDetail } from "./ChannelDetail";

interface CreateChannelLayoutProps {
  isEditReview?: boolean;
}
const ChannelModerationLayout = ({ isEditReview = false }: CreateChannelLayoutProps) => {
  const navContext = useNavigationBar();
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as { backgroundLocation?: Location };

  // const { showModal, confirmNavigation, cancelNavigation } = usePrompt("Are you sure you want to leave this page?", true);
  const {
    backArrow,
    title,
    subtitle,
    userActions,
    buttonTitle,
    enableLink,
    onBack,
    onClose,
    FilterButton,
    icon,
    onFilter,
    onNext,
    getActionItems,
    onActionItemSelect,
  } = navContext.navProps;

  // useEffect(() => {
  //   if (blocker.state === "blocked") {
  //     blocker.reset();
  //   }
  // }, [blocker]);

  return (
    <ModeratorChannelProvider isEditReview={isEditReview}>
      <div className="container-modal">
        <div className="relative container-modal-content">
          <div>
            <ContainerNavigation
              backArrow={backArrow}
              title={title}
              subtitle={subtitle}
              userActions={userActions}
              icon={icon}
              enableLink={enableLink}
              buttonTitle={buttonTitle}
              onBack={onBack}
              onClose={onClose}
              // FilterButton={FilterButton}
              onFilter={onFilter}
              getActionItems={getActionItems}
              onActionItemSelect={onActionItemSelect}
            />

            <div className="left-0 flex flex-col w-full h-[calc(100vh-200px)] overflow-y-auto top-[84px] ">
              <ChannelStatus />
              <Outlet />
              {/* {state.backgroundLocation && <ChannelDetail />} */}
            </div>
          </div>
        </div>
      </div>
    </ModeratorChannelProvider>
  );
};

// const ChannelStatus = () => {
//   const { channelData } = useContext(ModeratorChannelContext);

//   return (
//     <>
//       {channelData && (
//         <>
//           <div className="flex items-center justify-end mt-[5px]">
//             <div className="flex items-center">
//               {channelData?.status === ChannelState.ACTIVE && <span className="bg-skgreen w-[8px] h-[8px] rounded-full"></span>}
//               <p className="ml-1 capitalize">{getChannelStatusString(channelData?.status, channelData?.subStatus)}</p>
//             </div>
//           </div>
//         </>
//       )}
//     </>
//   );
// };

const ChannelStatus = () => {
  const { channelData, isEditReview, originalSubstate } = useContext(ModeratorChannelContext);

  return (
    <>
      {channelData && (
        <div className={`flex items-center gap-5 justify-end p-[3px] pr-3 ${isEditReview ? "!bg-[#FFCC00] h-[28px] mb-[35px]" : ""} `}>
          {channelData?.followerCount ? (
            <div className="flex items-center gap-1">
              <span className="capitalize edit-status-top  !text-sm !font-normal">{channelData.followerCount}</span>
              <span className="">followers</span>
            </div>
          ) : (
            <></>
          )}
          <div className="flex items-center gap-1">
            <p className="capitalize edit-status-top">
              {isEditReview && originalSubstate
                ? getChannelEditStatusString(originalSubstate)
                : getChannelStatusString(channelData?.status, channelData.subStatus)}
            </p>
            {!isEditReview && channelData?.status === ChannelState.ACTIVE && (
              <span>
                <img src={"/icons/CheckItem.png"} className="object-contain w-[14px] h-[14px] min-w-5" alt="Certification status" />
              </span>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ChannelModerationLayout;
